import {registerRoute as workbox_routing_registerRoute} from '/vercel/path0/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/vercel/path0/node_modules/workbox-strategies/NetworkFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/vercel/path0/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/vercel/path0/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/vercel/path0/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {RangeRequestsPlugin as workbox_range_requests_RangeRequestsPlugin} from '/vercel/path0/node_modules/workbox-range-requests/RangeRequestsPlugin.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/vercel/path0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/vercel/path0/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/vercel/path0/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/_next/static/chunks/245-a02bca555935b2c2.js",
    "revision": "a02bca555935b2c2"
  },
  {
    "url": "/_next/static/chunks/245-a02bca555935b2c2.js.map",
    "revision": "e3b293f38f6529f1c177d773fcaf5dcc"
  },
  {
    "url": "/_next/static/chunks/276.e7f3142966674cf3.js",
    "revision": "e7f3142966674cf3"
  },
  {
    "url": "/_next/static/chunks/276.e7f3142966674cf3.js.map",
    "revision": "cbbc15e77642168699e4e2b44afd60fb"
  },
  {
    "url": "/_next/static/chunks/33.fdb13e7cb61c1548.js",
    "revision": "fdb13e7cb61c1548"
  },
  {
    "url": "/_next/static/chunks/33.fdb13e7cb61c1548.js.map",
    "revision": "a6867727897eb9ac249781de6d9cc50b"
  },
  {
    "url": "/_next/static/chunks/351.e7f038d1a10bf078.js",
    "revision": "e7f038d1a10bf078"
  },
  {
    "url": "/_next/static/chunks/351.e7f038d1a10bf078.js.map",
    "revision": "64e50968cc72d0a75526755ad66b25e0"
  },
  {
    "url": "/_next/static/chunks/636.1c9aafefbc1c227f.js",
    "revision": "1c9aafefbc1c227f"
  },
  {
    "url": "/_next/static/chunks/636.1c9aafefbc1c227f.js.map",
    "revision": "9b6016c129a9c9e5368e43d08a912ce1"
  },
  {
    "url": "/_next/static/chunks/728.631bf8699e6593a7.js",
    "revision": "631bf8699e6593a7"
  },
  {
    "url": "/_next/static/chunks/728.631bf8699e6593a7.js.map",
    "revision": "53e0b127903b182dc9083b6dbbc48dd6"
  },
  {
    "url": "/_next/static/chunks/873.2802f692554209b1.js",
    "revision": "2802f692554209b1"
  },
  {
    "url": "/_next/static/chunks/873.2802f692554209b1.js.map",
    "revision": "0b0b26be3a243520868f63744ff1a1ef"
  },
  {
    "url": "/_next/static/chunks/framework-9a72666fce3d906b.js",
    "revision": "9a72666fce3d906b"
  },
  {
    "url": "/_next/static/chunks/framework-9a72666fce3d906b.js.map",
    "revision": "66a37cc242a545040dc187f76082f507"
  },
  {
    "url": "/_next/static/chunks/main-c927c5637cbb6d5d.js",
    "revision": "c927c5637cbb6d5d"
  },
  {
    "url": "/_next/static/chunks/main-c927c5637cbb6d5d.js.map",
    "revision": "c62254104fd4c78f652b445265f754b6"
  },
  {
    "url": "/_next/static/chunks/pages/_app-d55de657a635fe33.js",
    "revision": "d55de657a635fe33"
  },
  {
    "url": "/_next/static/chunks/pages/_app-d55de657a635fe33.js.map",
    "revision": "d80acb1e6a4404cf08d53b1e2b9965b7"
  },
  {
    "url": "/_next/static/chunks/pages/_error-80427d174effb2ef.js",
    "revision": "80427d174effb2ef"
  },
  {
    "url": "/_next/static/chunks/pages/_error-80427d174effb2ef.js.map",
    "revision": "5330c0d3c9648cc1193bb86eb099ef1d"
  },
  {
    "url": "/_next/static/chunks/pages/index-5e4fdd22d988cc1b.js",
    "revision": "5e4fdd22d988cc1b"
  },
  {
    "url": "/_next/static/chunks/pages/index-5e4fdd22d988cc1b.js.map",
    "revision": "88b5703ee7a3ba08e742498acc4991fb"
  },
  {
    "url": "/_next/static/chunks/polyfills-c67a75d1b6f99dc8.js",
    "revision": "837c0df77fd5009c9e46d446188ecfd0"
  },
  {
    "url": "/_next/static/chunks/webpack-619bedba38f94a2b.js",
    "revision": "619bedba38f94a2b"
  },
  {
    "url": "/_next/static/chunks/webpack-619bedba38f94a2b.js.map",
    "revision": "3aa4efa40b2ee02812b798e1d67a1838"
  },
  {
    "url": "/_next/static/css/152eb6df0c44dd6f.css",
    "revision": "152eb6df0c44dd6f"
  },
  {
    "url": "/_next/static/css/152eb6df0c44dd6f.css.map",
    "revision": "7fe37786dd0cb1bb077903473363c314"
  },
  {
    "url": "/_next/static/gLEmtaXd3ZsiRVYXPF5YV/_buildManifest.js",
    "revision": "55a826bd22725712c739d8e96df38960"
  },
  {
    "url": "/_next/static/gLEmtaXd3ZsiRVYXPF5YV/_ssgManifest.js",
    "revision": "b6652df95db52feb4daf4eca35380933"
  },
  {
    "url": "/_next/static/media/1.b72000a6.woff2",
    "revision": "b72000a6"
  },
  {
    "url": "/_next/static/media/10.87a1afae.woff2",
    "revision": "87a1afae"
  },
  {
    "url": "/_next/static/media/11.8f61af6d.woff2",
    "revision": "8f61af6d"
  },
  {
    "url": "/_next/static/media/12.fe8484d9.woff2",
    "revision": "fe8484d9"
  },
  {
    "url": "/_next/static/media/13.b3b48127.woff2",
    "revision": "b3b48127"
  },
  {
    "url": "/_next/static/media/14.353e7bf4.woff2",
    "revision": "353e7bf4"
  },
  {
    "url": "/_next/static/media/15.0146ae14.woff2",
    "revision": "0146ae14"
  },
  {
    "url": "/_next/static/media/16.104c293f.woff2",
    "revision": "104c293f"
  },
  {
    "url": "/_next/static/media/17.3307da61.woff2",
    "revision": "3307da61"
  },
  {
    "url": "/_next/static/media/18.76412f87.woff2",
    "revision": "76412f87"
  },
  {
    "url": "/_next/static/media/2.4531dd39.woff2",
    "revision": "4531dd39"
  },
  {
    "url": "/_next/static/media/3.2ddad1d0.woff2",
    "revision": "2ddad1d0"
  },
  {
    "url": "/_next/static/media/4.9dbae7f6.woff2",
    "revision": "9dbae7f6"
  },
  {
    "url": "/_next/static/media/5.2178407d.woff2",
    "revision": "2178407d"
  },
  {
    "url": "/_next/static/media/6.e7ebaccd.woff2",
    "revision": "e7ebaccd"
  },
  {
    "url": "/_next/static/media/7.a4a278e0.woff2",
    "revision": "a4a278e0"
  },
  {
    "url": "/_next/static/media/8.cefcfa53.woff2",
    "revision": "cefcfa53"
  },
  {
    "url": "/_next/static/media/9.85f46950.woff2",
    "revision": "85f46950"
  },
  {
    "url": "/_next/static/media/dji-mavic-2.20498ed9.webp",
    "revision": "d7e244c02dc8843f98cdb704d06041b4"
  },
  {
    "url": "/_next/static/media/footer-video-poster.80c80584.webp",
    "revision": "91caa4b62d46fa6624e77e136a61b8b7"
  },
  {
    "url": "/_next/static/media/header-video-poster.2b103c93.webp",
    "revision": "92d66158c7b825b21012d610e08b08ed"
  },
  {
    "url": "/_next/static/media/showreel-video-poster.70c35891.webp",
    "revision": "96402a82a5c244544d3c92409d2a8e18"
  },
  {
    "url": "/animations/cinema-grade-equipments.svg",
    "revision": "40f721f6d813f3c1afbcd68d82d81fb7"
  },
  {
    "url": "/animations/corporate-videos.svg",
    "revision": "049c47ecf7106dc0a7e76c2702b54a5e"
  },
  {
    "url": "/animations/digital-advertisement.svg",
    "revision": "d9367429a94f9aa755b4e080b2659ffc"
  },
  {
    "url": "/animations/drone-videography.svg",
    "revision": "b8236d2109f1988d4c7403d887600ceb"
  },
  {
    "url": "/animations/infinity-spinner.svg",
    "revision": "e59c9a7d0267b1ee7584e58fd3ad1950"
  },
  {
    "url": "/animations/product-videos.svg",
    "revision": "d77a97c4f26a9a4bf0192d5b3d4e3cfb"
  },
  {
    "url": "/animations/specialised-video-solutions.svg",
    "revision": "a8ddabb493ad31abbb98ab5accbc8575"
  },
  {
    "url": "/animations/testimonials.svg",
    "revision": "031c019bc30234c6cdc89c53b05ed2e6"
  },
  {
    "url": "/animations/trained-professionals.svg",
    "revision": "d8f1bcf5d294c4b072c734466dd6a29a"
  },
  {
    "url": "/animations/video-editing.svg",
    "revision": "1478edebd434dbca13bf381fd67bb03e"
  },
  {
    "url": "/fonts/dm-sans/1.woff2",
    "revision": "ecfb2eeb6820b2b78c4174894757ef39"
  },
  {
    "url": "/fonts/dm-sans/10.woff2",
    "revision": "715796ddd1637e1334588181b0e9cdb5"
  },
  {
    "url": "/fonts/dm-sans/11.woff2",
    "revision": "7cde51d22170a16ad99db9e3096c8ce2"
  },
  {
    "url": "/fonts/dm-sans/12.woff2",
    "revision": "ca72fb4e277e59be50b8850190822581"
  },
  {
    "url": "/fonts/dm-sans/13.woff2",
    "revision": "5cbc7a304a385a701c0182807f63e63b"
  },
  {
    "url": "/fonts/dm-sans/14.woff2",
    "revision": "5f0fea5efc035d1fcf0ca04910d57f55"
  },
  {
    "url": "/fonts/dm-sans/15.woff2",
    "revision": "9450c2979e72f16372b9961f992e6bcb"
  },
  {
    "url": "/fonts/dm-sans/16.woff2",
    "revision": "aa79315c4956ff3f32710ee5faa6c924"
  },
  {
    "url": "/fonts/dm-sans/17.woff2",
    "revision": "77621cbff1e65fc149acfe1b3d3c4564"
  },
  {
    "url": "/fonts/dm-sans/18.woff2",
    "revision": "d451decbad0d0d2feba27610481a34d8"
  },
  {
    "url": "/fonts/dm-sans/2.woff2",
    "revision": "be2a14878eb61d7c95d5970ff1912539"
  },
  {
    "url": "/fonts/dm-sans/3.woff2",
    "revision": "5ba1ad01a8d0d8de4aac13d4266d24ff"
  },
  {
    "url": "/fonts/dm-sans/4.woff2",
    "revision": "8ae11c10f084377afc74f4ec037a7e16"
  },
  {
    "url": "/fonts/dm-sans/5.woff2",
    "revision": "c8b1d073fccf586945cea101184eac4b"
  },
  {
    "url": "/fonts/dm-sans/6.woff2",
    "revision": "b04ef08ba8e7c6adc660cd64cc768ad1"
  },
  {
    "url": "/fonts/dm-sans/7.woff2",
    "revision": "d8cdecc881af604e33f6a2a04ec09def"
  },
  {
    "url": "/fonts/dm-sans/8.woff2",
    "revision": "f29503a1895affee5ed85d0246238af8"
  },
  {
    "url": "/fonts/dm-sans/9.woff2",
    "revision": "53577351d2c062d8af0d50032d2e68a6"
  },
  {
    "url": "/fonts/dm-sans/dm-sans.css",
    "revision": "1df7ad159d1d1eaae069cde3d0377c9e"
  },
  {
    "url": "/fonts/poppins/1.woff2",
    "revision": "a35c80beaba9ed0756dc2d3df3f333f9"
  },
  {
    "url": "/fonts/poppins/10.woff2",
    "revision": "c2abc7125e03efec7f33b98eac79b0e1"
  },
  {
    "url": "/fonts/poppins/11.woff2",
    "revision": "26a49607929a883135256687799cc190"
  },
  {
    "url": "/fonts/poppins/12.woff2",
    "revision": "83678295859259ae5dee89f6f1a97ed1"
  },
  {
    "url": "/fonts/poppins/13.woff2",
    "revision": "3e90412294a70b9f2807730a9dcd7101"
  },
  {
    "url": "/fonts/poppins/14.woff2",
    "revision": "de5313edc4a19506001361537f5b4a54"
  },
  {
    "url": "/fonts/poppins/15.woff2",
    "revision": "586bea02b1f51cf7dfd1a374111d51b8"
  },
  {
    "url": "/fonts/poppins/16.woff2",
    "revision": "0dcaea98952ac191083df4aeb1b21b24"
  },
  {
    "url": "/fonts/poppins/17.woff2",
    "revision": "f99245320288ea1579078fb33ad36e8d"
  },
  {
    "url": "/fonts/poppins/18.woff2",
    "revision": "9ddc04912d6e8f88d9de4045b8b89c59"
  },
  {
    "url": "/fonts/poppins/19.woff2",
    "revision": "d5e78c53cb0716cfec0b96fe178870f9"
  },
  {
    "url": "/fonts/poppins/2.woff2",
    "revision": "948727c902a57e732053272b5c449dcd"
  },
  {
    "url": "/fonts/poppins/20.woff2",
    "revision": "4d1490f32451df75d9cdcccb0c82874c"
  },
  {
    "url": "/fonts/poppins/21.woff2",
    "revision": "9ed361bba8488aeb2797b82befda20f1"
  },
  {
    "url": "/fonts/poppins/22.woff2",
    "revision": "fd9b8290076bb123b576fa8a79ad7986"
  },
  {
    "url": "/fonts/poppins/23.woff2",
    "revision": "d214b888d8959093716f8af6761a0226"
  },
  {
    "url": "/fonts/poppins/24.woff2",
    "revision": "84780596e268aa0cb2be48af2ed5c375"
  },
  {
    "url": "/fonts/poppins/25.woff2",
    "revision": "c384dc9ab3b6f9b90d515afa841af52a"
  },
  {
    "url": "/fonts/poppins/26.woff2",
    "revision": "8ed7cb7cb3f025303cdbedfa05d6cf54"
  },
  {
    "url": "/fonts/poppins/27.woff2",
    "revision": "087457026965f98466618a478c4b1b07"
  },
  {
    "url": "/fonts/poppins/28.woff2",
    "revision": "b9f2c13fc3617c3b1bba74575cc473e8"
  },
  {
    "url": "/fonts/poppins/29.woff2",
    "revision": "62d7a4c78fc2b6d74fa84c0ee8f9f7eb"
  },
  {
    "url": "/fonts/poppins/3.woff2",
    "revision": "020e7a3762470c85aef405ce3351b026"
  },
  {
    "url": "/fonts/poppins/30.woff2",
    "revision": "f4f17fd53c7d040e56f91a3ecb692b22"
  },
  {
    "url": "/fonts/poppins/4.woff2",
    "revision": "e1407cf31f1739862adfa6d4f91d25e9"
  },
  {
    "url": "/fonts/poppins/5.woff2",
    "revision": "aaefa4cfcaa73c8ab2ba1310939ec9dd"
  },
  {
    "url": "/fonts/poppins/6.woff2",
    "revision": "c8844b2518e608504a044c16951c094e"
  },
  {
    "url": "/fonts/poppins/7.woff2",
    "revision": "0bd2983444e357cd4944c5775f6d4286"
  },
  {
    "url": "/fonts/poppins/8.woff2",
    "revision": "c4b3e2ccf7ff44112724d7dfc9bf902f"
  },
  {
    "url": "/fonts/poppins/9.woff2",
    "revision": "97ac1837f7e7dbb299cf005f13987ef9"
  },
  {
    "url": "/fonts/poppins/poppins.css",
    "revision": "e0866e03c04b744ea267ac994290de30"
  },
  {
    "url": "/images/badges/vercel-badge-failing.png",
    "revision": "d3458822ce2934f093195855b0e08414"
  },
  {
    "url": "/images/badges/vercel-badge-passing.png",
    "revision": "d86014cd837973f857d85d6b557518cd"
  },
  {
    "url": "/images/badges/vercel-badge-pending.png",
    "revision": "46414e2e0bc09f49e4ec8a6332113d25"
  },
  {
    "url": "/images/icons/logo/favicon_1024.png",
    "revision": "dbc00e36abca187eafd2d5d2bc20624c"
  },
  {
    "url": "/images/icons/logo/favicon_1024_m.png",
    "revision": "0a25b55d646f9abaf1a359d32d1701df"
  },
  {
    "url": "/images/icons/logo/favicon_144.png",
    "revision": "9a22edb349d9856023a0290d5ea549ef"
  },
  {
    "url": "/images/icons/logo/favicon_144_m.png",
    "revision": "20517c9e832af2aabf1eca70d78e04e4"
  },
  {
    "url": "/images/icons/logo/favicon_192.png",
    "revision": "221182502f612994e9664eb19a4489bf"
  },
  {
    "url": "/images/icons/logo/favicon_192_m.png",
    "revision": "0cb2e9deed7a130e95731c644753faf6"
  },
  {
    "url": "/images/icons/logo/favicon_48.png",
    "revision": "63457ac5a99a7ca6587fc0e9c102412b"
  },
  {
    "url": "/images/icons/logo/favicon_48_m.png",
    "revision": "3ac19ef879b3a64b5770d2adaf076671"
  },
  {
    "url": "/images/icons/logo/favicon_512.png",
    "revision": "1c89082bc2d3ecd4ba758c7a2e414cd8"
  },
  {
    "url": "/images/icons/logo/favicon_512_m.png",
    "revision": "33e97b9cc725267e84eab9e20337db80"
  },
  {
    "url": "/images/icons/logo/favicon_72.png",
    "revision": "9217d1d4451b5ff43a1a6c6a4e562d65"
  },
  {
    "url": "/images/icons/logo/favicon_72_m.png",
    "revision": "cf9e2f7bcf34f3a70bba00b6f01a7b84"
  },
  {
    "url": "/images/icons/logo/favicon_96.png",
    "revision": "b1d08afa540d990ea2ba8415d8bbeefb"
  },
  {
    "url": "/images/icons/logo/favicon_96_m.png",
    "revision": "5cddb5c5760e5975be34c3cd499575af"
  },
  {
    "url": "/images/icons/logo/favicon_maskable_512.png",
    "revision": "6db4605be782b2838abf3886e6b7196b"
  },
  {
    "url": "/images/icons/logo/favicon_maskable_512_m.png",
    "revision": "33e97b9cc725267e84eab9e20337db80"
  },
  {
    "url": "/images/icons/logo/og_512.jpg",
    "revision": "a73b97c0519c620300554c0a3ccc1d4b"
  },
  {
    "url": "/images/icons/logo/og_512_m.jpg",
    "revision": "236acfec243f3c013d4338cabe3b1285"
  },
  {
    "url": "/images/icons/social/facebook.svg",
    "revision": "3d8a165d78cc2cd7a4aa5864795e80c6"
  },
  {
    "url": "/images/icons/social/instagram.svg",
    "revision": "3b28e5cf38fff78251f2244d91588bd3"
  },
  {
    "url": "/images/icons/social/linkedin.svg",
    "revision": "f74d2e58de01c6287cdd3ef6c2792a2c"
  },
  {
    "url": "/images/icons/social/twitter.svg",
    "revision": "2b42463cd6fdfe219bb5403dd4045a49"
  },
  {
    "url": "/images/icons/social/youtube.svg",
    "revision": "26fa639d298042416580a11cd508a902"
  },
  {
    "url": "/images/illustrations/common/ImageNotFound.svg",
    "revision": "de8f70a7eff562f2637e58b6bd0363fc"
  },
  {
    "url": "/images/illustrations/common/ImageNotFoundPadded.svg",
    "revision": "682b3db29ad89ed9a1301b90addc13ea"
  },
  {
    "url": "/images/illustrations/common/PageNotFound.svg",
    "revision": "48b75d5ee0009c0a6015560e8791f978"
  },
  {
    "url": "/images/illustrations/common/ServerError.svg",
    "revision": "bdc02d25895b3c2602e6411b68ca0631"
  },
  {
    "url": "/images/illustrations/common/invalid_tracker_id.png",
    "revision": "a9ced7cc20f79aaf8051efb3f72688a5"
  },
  {
    "url": "/images/illustrations/index/about-us/trained-professionals.svg",
    "revision": "bab628a58f0155330e49af7ed24af3c9"
  },
  {
    "url": "/images/illustrations/index/dji-mavic-2.png",
    "revision": "0a3ae92ef9080bff27376f56f2bc16d7"
  },
  {
    "url": "/images/illustrations/index/dji-mavic-2.webp",
    "revision": "d7e244c02dc8843f98cdb704d06041b4"
  },
  {
    "url": "/images/illustrations/index/services/video-editing.svg",
    "revision": "26a6d1739285620c8c5e7d45f2f8ad70"
  },
  {
    "url": "/images/logo/logo-footer.svg",
    "revision": "3cda23c9dc7f29cca375a30401deb1c7"
  },
  {
    "url": "/images/logo/logo-footer_m.svg",
    "revision": "b2ba92a321ddbb5ff4b9982a13b006f6"
  },
  {
    "url": "/images/logo/logo-swipeable-drawer.svg",
    "revision": "ff52f35c49dd8feb8a657e2a9c222fb1"
  },
  {
    "url": "/images/logo/logo-swipeable-drawer_m.svg",
    "revision": "7497fd48b20d7d94e1b863ef77ef14f3"
  },
  {
    "url": "/images/logo/logo-white-footer.svg",
    "revision": "9f7c657f732ec3918adb6a53f749589a"
  },
  {
    "url": "/images/logo/logo-white-footer_m.svg",
    "revision": "0311a1013d874a71a8d799db54ff20d4"
  },
  {
    "url": "/images/logo/logo-white.svg",
    "revision": "9f7c657f732ec3918adb6a53f749589a"
  },
  {
    "url": "/images/logo/logo-white_m.svg",
    "revision": "04b1e5b4c39940a110937e52f15e4b77"
  },
  {
    "url": "/images/logo/logo.svg",
    "revision": "3cda23c9dc7f29cca375a30401deb1c7"
  },
  {
    "url": "/images/logo/logo_m.svg",
    "revision": "5402b8fa8330b877e046b1cd96efbd59"
  },
  {
    "url": "/images/uploads/example.tiff",
    "revision": "80775b2bc3adcde43aa774cbe8a09fc2"
  },
  {
    "url": "/images/uploads/false-thats-not-possible.webp",
    "revision": "2ecaa0c04635de2f4e5109a302cc8298"
  },
  {
    "url": "/images/uploads/fox-statues.avif",
    "revision": "0fed3ba0ecce1d7ef8b0d36cba10f0a6"
  },
  {
    "url": "/images/uploads/logo-white.svg",
    "revision": "85a02de2311d212f5e993fe8e9231ffc"
  },
  {
    "url": "/images/uploads/logo.svg",
    "revision": "384e951c7ef9d44c81a6b19517176347"
  },
  {
    "url": "/images/uploads/water-mountain.jpg",
    "revision": "e1d8ba019052511e7fe885db3ef0fa7d"
  },
  {
    "url": "/images/uploads/water-mountain.webp",
    "revision": "9858ba0edfa0cae0ddcfc531c04aa01c"
  },
  {
    "url": "/images/video-posters/footer-video-poster.webp",
    "revision": "91caa4b62d46fa6624e77e136a61b8b7"
  },
  {
    "url": "/images/video-posters/header-video-poster.webp",
    "revision": "92d66158c7b825b21012d610e08b08ed"
  },
  {
    "url": "/images/video-posters/showreel-video-poster.webp",
    "revision": "96402a82a5c244544d3c92409d2a8e18"
  },
  {
    "url": "/index.html",
    "revision": "223410b21da31efe86c3d7d514a91f09"
  },
  {
    "url": "/manifest.json",
    "revision": "fdc817e9f63ac23e6a1b0a3b02d09369"
  },
  {
    "url": "/robots.txt",
    "revision": "ffdb9207270c5ca3b1f06251e170f8b6"
  },
  {
    "url": "/scripts/gtm.js",
    "revision": "6becc8606b2f9409cacd8475898bdd39"
  },
  {
    "url": "/scripts/index.js",
    "revision": "cf98489a990676c71baa54cfb5069fc3"
  },
  {
    "url": "/scripts/recaptcha-enterprise-testing-high-risk.js",
    "revision": "f31a409ac7a9b539cd7472540715cb5c"
  },
  {
    "url": "/scripts/recaptcha-enterprise-testing.js",
    "revision": "1ab7fce54b77d2bb133082ba75d832e4"
  },
  {
    "url": "/scripts/recaptcha-enterprise.js",
    "revision": "c4756dc77770f2bb162fd035b7c32255"
  },
  {
    "url": "/sitemap.xml",
    "revision": "4b6c7a9b7916df8de0e0cbad54a1d93d"
  },
  {
    "url": "/styles/index.css",
    "revision": "06b0c61fc0c26fa0722ffc95f266f012"
  },
  {
    "url": "/videos/footer-video.mp4",
    "revision": "c535dbc1c670724e2cd0be33ba9b3e9e"
  },
  {
    "url": "/videos/footer-video.ogv",
    "revision": "806460e77b158401d16418ee3f3963ef"
  },
  {
    "url": "/videos/footer-video.webm",
    "revision": "dfd88b752fe44abfd071d0074b36b053"
  },
  {
    "url": "/videos/header-video.mp4",
    "revision": "3b6a31a28e9d9f4b5b42bab78a4e0f2b"
  },
  {
    "url": "/videos/header-video.ogv",
    "revision": "6005b98c6a3492d276b4de14a1cebd3f"
  },
  {
    "url": "/videos/header-video.webm",
    "revision": "34599d6467eed8c412e7c114c2827a9c"
  },
  {
    "url": "/videos/showreel.mp4",
    "revision": "c702be83d0b813e5810ea0b48b80afc1"
  },
  {
    "url": "/videos/showreel.ogv",
    "revision": "b34bfcb8f81d50d1ef1b757571a5fa0c"
  },
  {
    "url": "/videos/showreel.webm",
    "revision": "883e94f47f25ad106cffa6355768687e"
  }
], {
  "ignoreURLParametersMatching": []
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ request, response, event, state }) => { if (response && response.type === 'opaqueredirect') { return new Response(response.body, { status: 200, statusText: 'OK', headers: response.headers }) } return response } }] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:gstatic)\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts-webfonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:googleapis)\.com\/.*/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"google-fonts-stylesheets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:eot|otf|ttc|ttf|woff|woff2|font.css)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-font-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 4, maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:jpg|jpeg|gif|png|svg|ico|webp)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-image-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/image\?url=.+$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-image", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp3|wav|ogg)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-audio-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp4)$/i, new workbox_strategies_CacheFirst({ "cacheName":"static-video-assets", plugins: [new workbox_range_requests_RangeRequestsPlugin(), new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:js)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-js-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|less)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-style-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\/_next\/data\/.+\/.+\.json$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"next-data", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:json|xml|csv)$/i, new workbox_strategies_NetworkFirst({ "cacheName":"static-data-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      // Exclude /api/auth/callback/* to fix OAuth workflow in Safari without impact other environment
      // Above route is default for next-auth, you may need to change it if your OAuth workflow has a different callback route
      // Issue: https://github.com/shadowwalker/next-pwa/issues/131#issuecomment-821894809
      if (pathname.startsWith('/api/auth/')) return false
      if (pathname.startsWith('/api/')) return true
      return false
    }, new workbox_strategies_NetworkFirst({ "cacheName":"apis","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 16, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      if (!isSameOrigin) return false
      const pathname = url.pathname
      if (pathname.startsWith('/api/')) return false
      return true
    }, new workbox_strategies_NetworkFirst({ "cacheName":"others","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 86400 })] }), 'GET');
workbox_routing_registerRoute(({ url }) => {
      const isSameOrigin = self.origin === url.origin
      return !isSameOrigin
    }, new workbox_strategies_NetworkFirst({ "cacheName":"cross-origin","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 3600 })] }), 'GET');




